import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Alert, ListGroup, ListGroupItem } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as Patients from '../store/Patients';

class SelectPatientInternal extends React.Component {
    constructor(props) {
        super(props);

        var siteId = "";
        var siteName = "";
        var studyId = "";
        var studyName = "";
        if (props.siteId != null) {
            siteId = props.siteId;
        }
        if (props.siteName != null) {
            siteName = props.siteName;
        }
        if (props.studyId != null) {
            studyId = props.studyId;
        }
        if (props.studyName != null) {
            studyName = props.studyName;
        }
        this.state = {
            siteId: siteId,
            siteName: siteName,
            studyId: studyId,
            studyName: studyName
        };

        this.createListGroup = this.createListGroup.bind(this);
        this.initialize = this.initialize.bind(this);
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        this.initialize(null);
    }

    componentDidUpdate(prevProps) {
        this.initialize(prevProps);
    }

    createListGroup(patients) {
        const listItems = patients.map(patient => {
            const patientCode= patient.code;
            return (
                <ListGroupItem key={patient.id} tag={Link} to={{ pathname: paths.selectRecord, state: { patientCode: patientCode, patientId: patient.id, siteName: this.state.siteName, studyId: this.state.studyId, studyName: this.state.studyName } }} title={patientCode} action>
                    {patientCode}
                </ListGroupItem>
            );
        });
        return (
            <ListGroup>
                {listItems}
            </ListGroup>
        );
    }

    initialize(prevProps) {
        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAllRoles(accountsState);
        if (Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching)) {
            const siteId = this.state.siteId;
            const studyId = this.state.studyId;
            if (siteId === "") {
                this.props.patientsDispatch.getAllByAuthenticatedUserStudy(studyId);
            }
            else {
                this.props.patientsDispatch.getAllByStudyAndSite(studyId, siteId);
            }
        }
    }

    render() {
        if (!Accounts.authenticatedAllRoles(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        var error = false;
        var message = "";
        var patientList = null;

        const patients = this.props.patientsState.all;
        if (patients != null &&
            patients.length != null &&
            patients.map != null) {
            patientList = this.createListGroup(patients);
            if (patients.length <= 0) {
                message = "This site is not linked to any patients.";
            }
        }
        else {
            error = true;
            message = "Error retrieving patients.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        return (
            <div>
                <h1>Select Patient</h1>
                <br />
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                {patientList}
            </div>
        );
    }
}

const SelectPatientConnect = connect(
    state => ({
        accountsState: state.accounts,
        patientsState: state.patients
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        patientsDispatch: bindActionCreators(Patients.actionCreators, dispatch)
    })
)(SelectPatientInternal);

export default class SelectPatient extends React.Component {
    render() {
        var siteId = "";
        var siteName = "";
        var studyId = "";
        var studyName = "";

        const propsState = this.props.location.state;
        if (propsState != null) {
            if (propsState.siteId != null) {
                siteId = propsState.siteId;
            }
            if (propsState.siteName != null) {
                siteName = propsState.siteName;
            }
            if (propsState.studyId != null) {
                studyId = propsState.studyId;
            }
            if (propsState.studyName != null) {
                studyName = propsState.studyName;
            }
        }

        return (
            <ErrorBoundary>
                <SelectPatientConnect siteId={siteId} siteName={siteName} studyId={studyId} studyName={studyName} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SelectPatient.js